import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { LoginLayoutRoutes } from './login-layout.routing';

import { LoginComponent } from '../../pages/login/login.component';
import { PasswordResetComponent } from '../../pages/password-reset/password-reset.component';

import { MatCommonModule } from '@angular/material/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  imports: [
    MatCommonModule,
    MatChipsModule,
    MatFormFieldModule,
    MatInputModule,
    CommonModule,
    RouterModule.forChild(LoginLayoutRoutes),
    FormsModule
  ],
  declarations: [
    LoginComponent,
    PasswordResetComponent
  ]
})

export class LoginLayoutModule {}
